var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { useTheme } from "styled-components";
import { Box } from "../../Box";
export const TableBody = (_a) => {
    var { "data-testid": dataTestId, fixedHeight } = _a, rest = __rest(_a, ["data-testid", "fixedHeight"]);
    const { colors: { tableColors }, } = useTheme();
    return (React.createElement(Box, Object.assign({ as: "tbody", backgroundColor: tableColors.tableBackground, "data-testid": dataTestId, height: fixedHeight, style: { overflowY: fixedHeight ? "scroll" : undefined } }, rest)));
};
